import { render, staticRenderFns } from "./JWAlertPreference.vue?vue&type=template&id=aab0dd0c&scoped=true&"
import script from "./JWAlertPreference.vue?vue&type=script&lang=js&"
export * from "./JWAlertPreference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aab0dd0c",
  null
  
)

export default component.exports